import React from 'react'

import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import { Loader } from '@components/Loader'
import { useFindTask } from '@hooks/task/find'

import { OfflineContainer } from './OfflineContainer'
import { TaskContainer } from './TaskContainer/Container'

const SafeAreaTop = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  padding-top: env(safe-area-inset-top);
`

export function TaskView() {
  const params = useParams()
  const taskId = Number(params.taskId)

  const { isLoading, isPaused, dataUpdatedAt } = useFindTask(taskId)

  if (dataUpdatedAt === 0 && isPaused) {
    return <OfflineContainer />
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100dvh' }}>
      <SafeAreaTop />
      {isLoading ? <Loader /> : <TaskContainer />}
    </div>
  )
}
